import { render, staticRenderFns } from "./explosionPreventionDoc.vue?vue&type=template&id=5b9b1cb0"
import script from "./explosionPreventionDoc.vue?vue&type=script&lang=js"
export * from "./explosionPreventionDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9b1cb0')) {
      api.createRecord('5b9b1cb0', component.options)
    } else {
      api.reload('5b9b1cb0', component.options)
    }
    module.hot.accept("./explosionPreventionDoc.vue?vue&type=template&id=5b9b1cb0", function () {
      api.rerender('5b9b1cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/chd/explosionPreventionDoc.vue"
export default component.exports